// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-card {
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  transition: box-shadow 0.2s;
  position: relative;
}

.reply-notice {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.78rem;
  color: var(--text-tertiary, var(--text-secondary));
  margin-bottom: 10px;
}

.reply-notice svg {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
  opacity: 0.7;
}

.reply-notice-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-weight: 500;
}

.reply-notice-link:hover {
  text-decoration: underline;
}

.post-card:hover {
  box-shadow: 0 2px 8px var(--shadow-color);
}

/* Highlight applied when returning from detail view */
.post-card.focus-highlight {
  animation: focus-pulse 1.6s ease-in-out;
  box-shadow: 0 6px 18px var(--shadow-color);
}

@keyframes focus-pulse {
  0% { border-color: var(--accent-primary); background-color: rgba(var(--overlay-bg), 0.6); }
}

@keyframes label-spin {
  to { transform: rotate(360deg); }
}

.label-loading-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-left: 5px;
  width: 1em;
  height: 1em;
  border: 0.15em solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: label-spin 0.7s linear infinite;
  flex-shrink: 0;
}

.muted-content-controls {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.post-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 12px;
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  max-width:90%;
}

.author-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
}

.optimistic-status.pending {
  display:none !important;
}

.post-author-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
  flex: 1 1;
}

.author-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.post-labels {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  gap: 6px;
  align-items: center;
  z-index: 10;
}

.post-label {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 12px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pinned-label {
  background: var(--bg-tertiary);
  color: var(--warning-color, #e8a838);
  border: 1px solid var(--warning-color, #e8a838);
  cursor: default;
}

.pinned-label.inactive {
  background: transparent;
  color: var(--text-secondary);
  border-color: var(--border-color);
  opacity: 0.4;
}

.feed-label {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  border: 1px solid var(--accent-primary);
}

.feed-label:hover {
  background: var(--accent-primary);
  color: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-color);
  text-decoration: none;
}

.community-label {
  background: var(--bg-tertiary);
  color: var(--accent-primary);
  border: 1px solid var(--accent-primary);
}

.community-label:hover {
  background: var(--accent-primary);
  color: var(--bg-tertiary);
  transform: translateY(-1px);
  box-shadow: 0 2px 4px var(--shadow-color);
  text-decoration: none;
}

.reply-label {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  border: 1px solid var(--border-color);
  font-style: italic;
  cursor: default;
}

/* Muted user placeholder */
.muted-user {
  background: var(--bg-tertiary);
  color: var(--text-secondary);
  padding: 10px;
  border-radius: 8px;
}

/* Reblog styles */
.reblog-label {
  font-size: 0.85rem;
  color: var(--text-secondary);
  font-style: italic;
  margin: 8px 0;
}

.reblog-commentary {
  margin: 8px 0 12px 0;
  padding: 8px 0;
  font-size: 14px;
  color: var(--text-primary);
  font-style: italic;
}

.reblog-commentary p {
  margin: 0;
  line-height: 1.5;
}

.reblog-content {
  background: var(--bg-tertiary);
  padding: 12px;
  border-radius: 8px;
  border-left: 3px solid var(--accent-primary);
  margin-top: 8px;
}

.reblog-original-header {
  margin-bottom: 8px;
}

.original-author {
  font-weight: 600;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.95rem;
}

.original-author:hover {
  text-decoration: underline;
}

.reblog-actions {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
}

.view-reblog-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.view-reblog-link:hover {
  text-decoration: underline;
}

.reblog-markdown-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.reblog-markdown-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text-primary);
}

.reblog-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 4px 0;
}

.reblog-url-link {
  color: var(--primary-color);
  text-decoration: none;
  word-break: break-all;
  font-size: 13px;
}

.reblog-url-link:hover {
  text-decoration: underline;
}

.author-info {
  display: flex;
  flex-direction: column;
}

.author-name {
  font-weight: 600;
  color: var(--text-primary);
  display: flex;
  align-items: center;
}

.post-date {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.reputation {
  background: var(--reputation-bg);
  color: var(--reputation-text);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.post-content-link {
  text-decoration: none;
  color: inherit;
}

.post-content-link:hover {
  text-decoration: none;
}

.post-card-article-title {
  margin: 0 0 10px;
  font-size: 1.5rem;
  line-height: 1.25;
}

.post-card-featured-image-wrap {
  display: block;
  margin: 0 0 10px;
  text-decoration: none;
}

.post-card-featured-image {
  width: 100%;
  height: auto;
  max-height: 320px;
  object-fit: cover;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  display: block;
}

.post-card-featured-image-placeholder {
  width: 100%;
  height: 180px;
  border-radius: 10px;
  border: 1px dashed var(--border-color);
  background: var(--bg-tertiary);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-secondary);
  font-size: 0.9rem;
  font-weight: 600;
}

.post-card-article-title-link {
  color: var(--text-primary);
  text-decoration: none;
}

.post-card-article-title-link:hover {
  color: var(--accent-primary);
  text-decoration: none;
}

.post-body {
  color: var(--text-primary);
  line-height: 1.5;
  margin-bottom: 12px;
  word-wrap: break-word;
}

.post-time {
  font-size: 12px;
  color: var(--text-secondary);
  cursor: default;
}

.post-via-app {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 6px;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text-secondary);
  vertical-align: middle;
}

.post-via-app em {
  font-style: italic;
  overflow: hidden;
  text-overflow: ellipsis;
}

.optimistic-status {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 12px;
  margin-bottom: 8px;
  background: var(--bg-tertiary);
  color: var(--text-secondary);
}

.optimistic-status.failed {
  background: rgba(255, 99, 71, 0.12);
  color: #ff6347;
}

.retry-optimistic-btn {
  background: transparent;
  border: 1px solid currentColor;
  color: inherit;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  cursor: pointer;
}

.retry-optimistic-btn:hover {
  opacity: 0.8;
}

.post-images {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.post-image {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  border: 1px solid var(--border-color);
}

.read-more-indicator {
  color: var(--accent-primary);
  font-weight: 500;
  margin-left: 4px;
}

.short-content-controls {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
}

.short-content-expand-btn {
  border: 1px solid var(--border-color);
  background: var(--bg-tertiary);
  color: var(--text-primary);
  border-radius: 10px;
  padding: 4px 10px;
  font-size: 0.85rem;
  cursor: pointer;
}

.short-content-expand-btn:hover {
  border-color: var(--accent-primary);
  color: var(--accent-primary);
}

.short-content-detail-link {
  color: var(--accent-primary);
  font-weight: 500;
  text-decoration: none;
}

.short-content-detail-link:hover {
  text-decoration: underline;
}

.post-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.tag {
  color: var(--accent-primary);
  font-size: 0.9rem;
  text-decoration: none;
}

.tag:hover {
  text-decoration: underline;
}

.post-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
  border-top: 1px solid var(--border-color);
  margin-top: 8px;
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.payout-info {
  font-weight: 600;
  color: var(--success-color);
}

.replies-count {
  color: var(--text-secondary);
}

@media (max-width: 768px) {
  .post-card {
    padding: 12px;
    border-radius: 8px;
  }

  .author-avatar {
    width: 35px;
    height: 35px;
  }
}

/* Post stats styling */
.post-stats {
  display: flex;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color);
  margin-top: 12px;
}

.stat {
  color: var(--text-secondary);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.comment-toggle-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-size: 0.9rem;
  color: var(--text-secondary);
  transition: color 0.2s;
}

.comment-toggle-btn:hover {
  color: var(--accent-primary);
}

/* Inline comments section */
.inline-comments-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 2px solid var(--border-color);
}

.comments-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.comments-header h4 {
  margin: 0;
  font-size: 1rem;
  color: var(--text-primary);
}

.view-all-link {
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
}

.view-all-link:hover {
  text-decoration: underline;
}

.no-comments-container {
  text-align: center;
  padding: 16px 0;
}

.no-comments {
  color: var(--text-secondary);
  font-style: italic;
  font-size: 0.9rem;
  margin: 8px 0 12px 0;
}

.be-first-btn {
  background: var(--accent-primary);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.be-first-btn:hover {
  background: var(--accent-hover);
  transform: translateY(-1px);
}

.inline-comments-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reply-login-prompt {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  margin-top: 12px;
  border: 1px solid var(--border-color);
  border-radius: 12px;
  background: var(--bg-tertiary);
}

.reply-login-prompt p {
  margin: 0;
  color: var(--text-secondary);
}

.inline-comment {
  padding: 10px;
  background: var(--bg-tertiary);
  border-radius: 8px;
  border-left: 3px solid var(--border-color);
  transition: border-color 0.2s;
}

.inline-comment:hover {
  border-left-color: var(--accent-primary);
}

.inline-comment-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.comment-author {
  font-weight: 600;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.9rem;
}

.comment-author:hover {
  text-decoration: underline;
}

.comment-time {
  font-size: 0.8rem;
  color: var(--text-secondary);
}

.inline-comment-body {
  color: var(--text-primary);
  line-height: 1.4;
  font-size: 0.9rem;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin-bottom: 8px;
}

.toggle-replies-btn-inline {
  background: transparent;
  border: none;
  color: var(--accent-primary);
  cursor: pointer;
  padding: 4px 8px;
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 4px;
}

.toggle-replies-btn-inline:hover {
  text-decoration: underline;
}

.inline-comment-replies {
  margin-top: 8px;
}

.view-deeper-link {
  display: inline-block;
  color: var(--accent-primary);
  text-decoration: none;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 6px 12px;
  background: var(--bg-secondary);
  border-radius: 6px;
  margin-top: 8px;
  border: 1px solid var(--border-color);
}

.view-deeper-link:hover {
  text-decoration: underline;
  background: var(--bg-tertiary);
}

/* Comments loading state */
.comments-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 20px;
  gap: 12px;
}

.comments-loading p {
  color: var(--text-secondary);
  font-size: 0.9rem;
  margin: 0;
}

.loading-dots {
  display: flex;
  gap: 8px;
  align-items: center;
}

.loading-dots .dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--accent-primary);
  animation: pulse-dot 1.4s infinite ease-in-out both;
}

.loading-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes pulse-dot {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.3;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PostCard/PostCard.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sDAAsD;AACtD;EACE,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,KAAK,mCAAmC,EAAE,8CAA8C,EAAE;AAC5F;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,iCAAiC;EACjC,6BAA6B;EAC7B,kBAAkB;EAClB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,qBAAqB;IACrB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF","sourcesContent":[".post-card {\r\n  background: var(--bg-secondary);\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  padding: 16px;\r\n  margin-bottom: 16px;\r\n  transition: box-shadow 0.2s;\r\n  position: relative;\r\n}\r\n\r\n.reply-notice {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 0.78rem;\r\n  color: var(--text-tertiary, var(--text-secondary));\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.reply-notice svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  flex-shrink: 0;\r\n  opacity: 0.7;\r\n}\r\n\r\n.reply-notice-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.reply-notice-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.post-card:hover {\r\n  box-shadow: 0 2px 8px var(--shadow-color);\r\n}\r\n\r\n/* Highlight applied when returning from detail view */\r\n.post-card.focus-highlight {\r\n  animation: focus-pulse 1.6s ease-in-out;\r\n  box-shadow: 0 6px 18px var(--shadow-color);\r\n}\r\n\r\n@keyframes focus-pulse {\r\n  0% { border-color: var(--accent-primary); background-color: rgba(var(--overlay-bg), 0.6); }\r\n}\r\n\r\n@keyframes label-spin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.label-loading-spinner {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  margin-left: 5px;\r\n  width: 1em;\r\n  height: 1em;\r\n  border: 0.15em solid currentColor;\r\n  border-top-color: transparent;\r\n  border-radius: 50%;\r\n  animation: label-spin 0.7s linear infinite;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.muted-content-controls {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.post-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.header-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  flex: 1;\r\n  max-width:90%;\r\n}\r\n\r\n.author-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.optimistic-status.pending {\r\n  display:none !important;\r\n}\r\n\r\n.post-author-link {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  flex: 1;\r\n}\r\n\r\n.author-avatar {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 50%;\r\n  object-fit: cover;\r\n}\r\n\r\n.post-labels {\r\n  position: absolute;\r\n  top: 12px;\r\n  right: 12px;\r\n  display: flex;\r\n  gap: 6px;\r\n  align-items: center;\r\n  z-index: 10;\r\n}\r\n\r\n.post-label {\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.pinned-label {\r\n  background: var(--bg-tertiary);\r\n  color: var(--warning-color, #e8a838);\r\n  border: 1px solid var(--warning-color, #e8a838);\r\n  cursor: default;\r\n}\r\n\r\n.pinned-label.inactive {\r\n  background: transparent;\r\n  color: var(--text-secondary);\r\n  border-color: var(--border-color);\r\n  opacity: 0.4;\r\n}\r\n\r\n.feed-label {\r\n  background: var(--bg-tertiary);\r\n  color: var(--accent-primary);\r\n  border: 1px solid var(--accent-primary);\r\n}\r\n\r\n.feed-label:hover {\r\n  background: var(--accent-primary);\r\n  color: var(--bg-tertiary);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 4px var(--shadow-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.community-label {\r\n  background: var(--bg-tertiary);\r\n  color: var(--accent-primary);\r\n  border: 1px solid var(--accent-primary);\r\n}\r\n\r\n.community-label:hover {\r\n  background: var(--accent-primary);\r\n  color: var(--bg-tertiary);\r\n  transform: translateY(-1px);\r\n  box-shadow: 0 2px 4px var(--shadow-color);\r\n  text-decoration: none;\r\n}\r\n\r\n.reply-label {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-secondary);\r\n  border: 1px solid var(--border-color);\r\n  font-style: italic;\r\n  cursor: default;\r\n}\r\n\r\n/* Muted user placeholder */\r\n.muted-user {\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-secondary);\r\n  padding: 10px;\r\n  border-radius: 8px;\r\n}\r\n\r\n/* Reblog styles */\r\n.reblog-label {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n  margin: 8px 0;\r\n}\r\n\r\n.reblog-commentary {\r\n  margin: 8px 0 12px 0;\r\n  padding: 8px 0;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  font-style: italic;\r\n}\r\n\r\n.reblog-commentary p {\r\n  margin: 0;\r\n  line-height: 1.5;\r\n}\r\n\r\n.reblog-content {\r\n  background: var(--bg-tertiary);\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  border-left: 3px solid var(--accent-primary);\r\n  margin-top: 8px;\r\n}\r\n\r\n.reblog-original-header {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.original-author {\r\n  font-weight: 600;\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.original-author:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.reblog-actions {\r\n  margin-top: 8px;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border-color);\r\n}\r\n\r\n.view-reblog-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.view-reblog-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.reblog-markdown-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.reblog-markdown-content p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.reblog-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 8px;\r\n  margin: 4px 0;\r\n}\r\n\r\n.reblog-url-link {\r\n  color: var(--primary-color);\r\n  text-decoration: none;\r\n  word-break: break-all;\r\n  font-size: 13px;\r\n}\r\n\r\n.reblog-url-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.author-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.author-name {\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.post-date {\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.reputation {\r\n  background: var(--reputation-bg);\r\n  color: var(--reputation-text);\r\n  padding: 4px 8px;\r\n  border-radius: 12px;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.post-content-link {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\n.post-content-link:hover {\r\n  text-decoration: none;\r\n}\r\n\r\n.post-card-article-title {\r\n  margin: 0 0 10px;\r\n  font-size: 1.5rem;\r\n  line-height: 1.25;\r\n}\r\n\r\n.post-card-featured-image-wrap {\r\n  display: block;\r\n  margin: 0 0 10px;\r\n  text-decoration: none;\r\n}\r\n\r\n.post-card-featured-image {\r\n  width: 100%;\r\n  height: auto;\r\n  max-height: 320px;\r\n  object-fit: cover;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border-color);\r\n  display: block;\r\n}\r\n\r\n.post-card-featured-image-placeholder {\r\n  width: 100%;\r\n  height: 180px;\r\n  border-radius: 10px;\r\n  border: 1px dashed var(--border-color);\r\n  background: var(--bg-tertiary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.post-card-article-title-link {\r\n  color: var(--text-primary);\r\n  text-decoration: none;\r\n}\r\n\r\n.post-card-article-title-link:hover {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n}\r\n\r\n.post-body {\r\n  color: var(--text-primary);\r\n  line-height: 1.5;\r\n  margin-bottom: 12px;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.post-time {\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  cursor: default;\r\n}\r\n\r\n.post-via-app {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  margin-left: 6px;\r\n  max-width: 220px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n  vertical-align: middle;\r\n}\r\n\r\n.post-via-app em {\r\n  font-style: italic;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.optimistic-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 6px 10px;\r\n  border-radius: 8px;\r\n  font-size: 12px;\r\n  margin-bottom: 8px;\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.optimistic-status.failed {\r\n  background: rgba(255, 99, 71, 0.12);\r\n  color: #ff6347;\r\n}\r\n\r\n.retry-optimistic-btn {\r\n  background: transparent;\r\n  border: 1px solid currentColor;\r\n  color: inherit;\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 11px;\r\n  cursor: pointer;\r\n}\r\n\r\n.retry-optimistic-btn:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.post-images {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-top: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.post-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.read-more-indicator {\r\n  color: var(--accent-primary);\r\n  font-weight: 500;\r\n  margin-left: 4px;\r\n}\r\n\r\n.short-content-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin-top: 8px;\r\n}\r\n\r\n.short-content-expand-btn {\r\n  border: 1px solid var(--border-color);\r\n  background: var(--bg-tertiary);\r\n  color: var(--text-primary);\r\n  border-radius: 10px;\r\n  padding: 4px 10px;\r\n  font-size: 0.85rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.short-content-expand-btn:hover {\r\n  border-color: var(--accent-primary);\r\n  color: var(--accent-primary);\r\n}\r\n\r\n.short-content-detail-link {\r\n  color: var(--accent-primary);\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n}\r\n\r\n.short-content-detail-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.post-tags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.tag {\r\n  color: var(--accent-primary);\r\n  font-size: 0.9rem;\r\n  text-decoration: none;\r\n}\r\n\r\n.tag:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.post-footer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border-color);\r\n  margin-top: 8px;\r\n  font-size: 0.85rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.payout-info {\r\n  font-weight: 600;\r\n  color: var(--success-color);\r\n}\r\n\r\n.replies-count {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .post-card {\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .author-avatar {\r\n    width: 35px;\r\n    height: 35px;\r\n  }\r\n}\r\n\r\n/* Post stats styling */\r\n.post-stats {\r\n  display: flex;\r\n  gap: 16px;\r\n  padding-top: 12px;\r\n  border-top: 1px solid var(--border-color);\r\n  margin-top: 12px;\r\n}\r\n\r\n.stat {\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n}\r\n\r\n.comment-toggle-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  font-size: 0.9rem;\r\n  color: var(--text-secondary);\r\n  transition: color 0.2s;\r\n}\r\n\r\n.comment-toggle-btn:hover {\r\n  color: var(--accent-primary);\r\n}\r\n\r\n/* Inline comments section */\r\n.inline-comments-section {\r\n  margin-top: 16px;\r\n  padding-top: 16px;\r\n  border-top: 2px solid var(--border-color);\r\n}\r\n\r\n.comments-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.comments-header h4 {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.view-all-link {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.view-all-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.no-comments-container {\r\n  text-align: center;\r\n  padding: 16px 0;\r\n}\r\n\r\n.no-comments {\r\n  color: var(--text-secondary);\r\n  font-style: italic;\r\n  font-size: 0.9rem;\r\n  margin: 8px 0 12px 0;\r\n}\r\n\r\n.be-first-btn {\r\n  background: var(--accent-primary);\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 20px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.be-first-btn:hover {\r\n  background: var(--accent-hover);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.inline-comments-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.reply-login-prompt {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  padding: 16px;\r\n  margin-top: 12px;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 12px;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.reply-login-prompt p {\r\n  margin: 0;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.inline-comment {\r\n  padding: 10px;\r\n  background: var(--bg-tertiary);\r\n  border-radius: 8px;\r\n  border-left: 3px solid var(--border-color);\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.inline-comment:hover {\r\n  border-left-color: var(--accent-primary);\r\n}\r\n\r\n.inline-comment-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.comment-author {\r\n  font-weight: 600;\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.comment-author:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.comment-time {\r\n  font-size: 0.8rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.inline-comment-body {\r\n  color: var(--text-primary);\r\n  line-height: 1.4;\r\n  font-size: 0.9rem;\r\n  white-space: pre-wrap;\r\n  word-wrap: break-word;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.toggle-replies-btn-inline {\r\n  background: transparent;\r\n  border: none;\r\n  color: var(--accent-primary);\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  margin-top: 4px;\r\n}\r\n\r\n.toggle-replies-btn-inline:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.inline-comment-replies {\r\n  margin-top: 8px;\r\n}\r\n\r\n.view-deeper-link {\r\n  display: inline-block;\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  font-size: 0.85rem;\r\n  font-weight: 500;\r\n  padding: 6px 12px;\r\n  background: var(--bg-secondary);\r\n  border-radius: 6px;\r\n  margin-top: 8px;\r\n  border: 1px solid var(--border-color);\r\n}\r\n\r\n.view-deeper-link:hover {\r\n  text-decoration: underline;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n/* Comments loading state */\r\n.comments-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 30px 20px;\r\n  gap: 12px;\r\n}\r\n\r\n.comments-loading p {\r\n  color: var(--text-secondary);\r\n  font-size: 0.9rem;\r\n  margin: 0;\r\n}\r\n\r\n.loading-dots {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.loading-dots .dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  background: var(--accent-primary);\r\n  animation: pulse-dot 1.4s infinite ease-in-out both;\r\n}\r\n\r\n.loading-dots .dot:nth-child(1) {\r\n  animation-delay: -0.32s;\r\n}\r\n\r\n.loading-dots .dot:nth-child(2) {\r\n  animation-delay: -0.16s;\r\n}\r\n\r\n@keyframes pulse-dot {\r\n  0%, 80%, 100% {\r\n    transform: scale(0.6);\r\n    opacity: 0.3;\r\n  }\r\n  40% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
